import React from 'react';

import styles from './PasswordEmailStep.module.scss';
import { useTranslation } from 'react-i18next';
import Password from 'components/common/Form/Password';
import Button, { ButtonStyles } from 'components/common/Form/Button';
import { STEPS } from 'components/Auth/Register/Register';
import usePasswordRules from 'hooks/common/usePasswordRules';
import PasswordRules from 'components/Auth/Register/PasswordEmailStep/PasswordRules';
import useSimpleTooltip from 'hooks/common/useSimpleTooltip';

const PasswordEmailStep = ({ values, errors, onChangeField, setStep }) => {
    const { t } = useTranslation();
    const passwordValidation = usePasswordRules(values.password);
    const isPasswordComplies =
        !!Object.values(passwordValidation).length && Object.values(passwordValidation).every((v) => v);
    const { tooltip, hoverFunctions } = useSimpleTooltip(t('auth:text.passwordDoesntMeetCriteria'), styles.tooltip);

    return (
        <>
            <div className={styles.title}>{t('auth:text.createAccount')}</div>
            <div className={styles.subtitle}>{t('auth:text.pleaseCreatePassword')}</div>
            <br />
            <Password
                placeholder={t('auth:form.newPassword')}
                value={values.password}
                onChangeField={onChangeField}
                error={errors.password}
                name='password'
                autoFocus
            />
            <Password
                placeholder={t('auth:form.confirmPassword')}
                value={values.confirmPassword}
                onChangeField={onChangeField}
                error={errors.confirmPassword}
                name='confirmPassword'
            />
            <div className={styles.tooltipContainer}>
                <div {...hoverFunctions}>
                    <Button
                        btnStyle={ButtonStyles.primary}
                        text={t('auth:text.createAccount')}
                        className={styles.button}
                        onClick={() => setStep(STEPS.password)}
                        disabled={!isPasswordComplies}
                    />
                </div>
                {!isPasswordComplies && tooltip}
            </div>
            <PasswordRules passwordValidation={passwordValidation} values={values} />
        </>
    );
};

export default PasswordEmailStep;
